import { createFileRoute, redirect } from '@tanstack/react-router';
import * as React from 'react';

import { OAuthCompleteForm } from '@/components/auth/oauth-complete-form';
import { trpcVanilla } from '@/lib/trpc/shared';

export const Route = createFileRoute('/_auth/oauth-complete')({
  beforeLoad: async () => {
    const me = await trpcVanilla.user.me.query().catch(() => null);
    if (me && me.status === 'ACTIVE') {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: OAuthCompletePage,
});

function OAuthCompletePage(): React.ReactElement {
  return (
    <section className="border-border bg-card rounded-2xl border p-8 shadow-[0_8px_24px_-12px_hsl(30_10%_30%/0.06)]">
      <h1 className="font-display text-2xl tracking-tight">Finaliser votre compte</h1>
      <p className="text-muted-foreground mt-2 text-sm">
        Quelques informations sont requises avant d'utiliser Devizy.
      </p>
      <div className="mt-8">
        <OAuthCompleteForm />
      </div>
    </section>
  );
}
